import { Pipe, PipeTransform } from '@angular/core';
import { enumerators } from 'src/dictionaries/enum.pt-BR';

@Pipe({
  name: 'enumText'
})
export class EnumTextPipe implements PipeTransform {

  transform(value: string, key: string): string {
    //Procurar Chave
    const enumerator = Object.entries(enumerators).find(k => k[0] == key);
    if (!enumerator) return 'Enumerador Não Encontrado';

    //Procurar Valor
    const option = Object.entries(enumerator[1]).find(v => v[0] == value);
    if (!option) return 'Opção Inválida';

    //Texto do Dicionário
    return option[1];
  }

}
